/* eslint-disable jsx-a11y/anchor-is-valid */
import { DateP } from '../../shared/datePicker';

export class DoctorSelectedToAppoinment extends React.Component {
  /**
   * Constructor de la clase DoctorSelectedToAppoinment.
   * @param {object} props - Propiedades del componente React.
   */
  constructor(props) {
    super(props);
    this.state = {
      min: parseText('Form.DatePicker.DaysToSelectBeforeActualDate'),
      max: parseText('Form.DatePicker.DaysToSelectAfterActualDate'),
    };
  }

  /**
   * Maneja el evento de selección del botón para la fecha más próxima y actualiza el estado y clases CSS.
   * @param {object} e - Evento click del botón.
   * @returns {void}
   */
  elementClass(e) {
    this.setState({ showInput: false });
    e.target.classList.add('active');
    document.querySelector('.fui-Input__input').classList.remove('active');
    let date = new Date(); // por ahora es mock
    this.props.getDateFromPicker(date);
  }

  /**
   * Maneja la selección de una fecha desde el DatePicker y actualiza el estado y clases CSS.
   * @param {Date} date - Fecha seleccionada.
   * @returns {void}
   */
  getDateSelected(date) {
    if (date) {
      this.setState({ showInput: true });
      document.querySelector('.fui-Input__input').classList.add('active');
      document.querySelector('.btn-nextDate').classList.remove('active');
      this.props.getDateFromPicker(date);
    }
  }

  /**
   * Renderiza el componente de selección de doctor y fecha para la cita.
   * @returns {JSX.Element} Elementos JSX a renderizar.
   */
  render() {
    return (
      <div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" id="doctorSelectedToAppoinment">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-form-select-content">
            <h4>{parseText('Form.Content.TitleFormAppoinment')}</h4>
            <hr />
          </div>

          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 buttons-select-appoinment">
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              <h4>{parseText('Form.Content.SelectAppoinment')}</h4>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9">
              <div
                className="col-xs-12 col-sm-12 col-md-4 col-lg-4 no-padding toggleNoxtDate"
                onClick={this.elementClass.bind(this)}
              >
                <a className="btn btn-default btn-nextDate ">{parseText('Form.DatePicker.ClosestDate')}</a>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 toggleDate">
                <DateP
                  showInput={this.state.showInput}
                  getDateSelected={this.getDateSelected.bind(this)}
                  min={this.state.min}
                  max={this.state.max}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
